/**
 * This file is kept for backward compatibility.
 * The hook is now in @punchup/ui-common package.
 */
export * from "@punchup/ui-common/shadcn/ui/use-toast";
